<section class="course-wrap">
  <div class="wrap-lg">
    <div class="course-inner">
      <div class="nav-sec">
        <div class="back-nav" (click)="back()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 6L9 12L15 18" stroke="#1A204B" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="nav-name">Back</span>
        </div>
      </div>
      <div class="page-head mob-stick">
        <div class="head-left">
          <div class="page-title">Select Course</div>
          <div class="page-info">Choose from our catalogue manually </div>
        </div>
        <div class="head-right">
          <div class="page-search">
            <input type="text" class="cus-input" [(ngModel)]="searchTerm" (input)="onInputChange()"
            placeholder="Search for courses in {{instituteName| slice:0:20}}"/>
            <svg class="search-icon" width="48" height="40" viewBox="0 0 48 40" fill="none" >
              <path d="M3.08964 10.2988C1.54977 5.16589 5.39334 0 10.7522 0H40C44.4183 0 48 3.58172 48 8V32C48 36.4183 44.4183 40 40 40H17.9522C14.4194 40 11.3048 37.6827 10.2896 34.2988L3.08964 10.2988Z" fill="#17151C"/>
              <path d="M27.6 27.2C31.7974 27.2 35.2 23.7974 35.2 19.6C35.2 15.4026 31.7974 12 27.6 12C23.4026 12 20 15.4026 20 19.6C20 23.7974 23.4026 27.2 27.6 27.2Z" stroke="#10D7EE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M36.0002 28L33.2002 25.2" stroke="#10D7EE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
      </div>
      <div class="search-result" *ngIf="searchTerm.length>0">Showing results for <span class="text">“{{searchTerm}}”</span></div>

      <div class="course-list" >
        <div class="course-item" *ngFor="let course of courses">
          <div class="course-top"(click)="util.isMobile ? selectCourse(course) : '' ">
            <div class="course-name">{{course.course_name}}</div>
            <div class="course-duration"><span class="lite">Duration:</span>{{getDuration(course.fee)?.termDurationInMonths
            }} months</div>
          </div>
          <svg class="mob-show arrow" (click)="selectCourse(course)" width="20" height="21" viewBox="0 0 20 21" fill="none">
            <path d="M8.63379 5.60367L13.549 10.5189L8.63379 15.4341" stroke="#17151C" stroke-width="1.82195" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <button class="btn-primary mob-hide" (click)="selectCourse(course)">Apply</button>
        </div>
        <!-- <div class="course-item">
          <div class="course-top">
            <div class="course-name">Year Long Program Online classes</div>
            <div class="course-duration"><span class="lite">Duration:</span>12 Months</div>
          </div>
          <button class="btn-primary">Apply</button>
        </div> -->
        <!-- <div class="course-item">
          <div class="course-top">
            <div class="course-name">Year Long Program Online classes</div>
            <div class="course-duration"><span class="lite">Duration:</span>12 Months</div>
          </div>
          <button class="btn-primary">Apply</button>
        </div>
        <div class="course-item">
          <div class="course-top">
            <div class="course-name">Year Long Program Online classes</div>
            <div class="course-duration"><span class="lite">Duration:</span>12 Months</div>
          </div>
          <button class="btn-primary">Apply</button>
        </div>
        <div class="course-item">
          <div class="course-top">
            <div class="course-name">Year Long Program Online classes</div>
            <div class="course-duration"><span class="lite">Duration:</span>12 Months</div>
          </div>
          <button class="btn-primary">Apply</button>
        </div>
        <div class="course-item">
          <div class="course-top">
            <div class="course-name">Year Long Program Online classes</div>
            <div class="course-duration"><span class="lite">Duration:</span>12 Months</div>
          </div>
          <button class="btn-primary">Apply</button>
        </div> -->
      </div>
      <app-no-results *ngIf="totalPages == 0"></app-no-results>
      <div class="pagination-sec" *ngIf="totalPages !=0 ">
        <div class="pagi-btn prev "(click)="prevPage()" [class.disable]="currentPage === 0"><img src="assets/images/icons/right_arrow_black.svg" alt="Arrow"/></div>
        <div class="pagi-btn active">{{currentPage+1}}/{{totalPages}}</div>
        <div class="pagi-btn next" (click)="nextPage()" [class.disable]="currentPage === totalPages-1"><img src="assets/images/icons/right_arrow_black.svg" alt="Arrow"/></div>
      </div>
    </div>
  </div>
</section>
